/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Updatedat1Inputs */

const en__field_updatedat1 = /** @type {(inputs: _Field_Updatedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last Change`)
};

const de__field_updatedat1 = /** @type {(inputs: _Field_Updatedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte Änderung am`)
};

/**
* | output |
* | --- |
* | "Last Change" |
*
* @param {_Field_Updatedat1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_updatedat1 = /** @type {((inputs?: _Field_Updatedat1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Updatedat1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_updatedat1(inputs)
	return de__field_updatedat1(inputs)
});
export { _field_updatedat1 as "_field_updatedAt" }